import { render, staticRenderFns } from "./Bing2.vue?vue&type=template&id=f8293ef0&scoped=true"
import script from "./Bing2.vue?vue&type=script&lang=js"
export * from "./Bing2.vue?vue&type=script&lang=js"
import style0 from "./Bing2.vue?vue&type=style&index=0&id=f8293ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8293ef0",
  null
  
)

export default component.exports